import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Testimonial from '../../components/Testimonial/Testimonial';


const TestimonialPage2 =() => {
    return(
        <Fragment>
            <PageTitle pageTitle={'Testimonial'} pagesub={'Testimonial'}/> 
            <Testimonial/>
            <Scrollbar/>
        </Fragment>
    )
};
export default TestimonialPage2;
